module.exports = __webpack_public_path__ + "static/img/3170_phase_function_Paper_PointsHejduk_Prediction.697d2df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3170_phase_function_Paper_PointsHejduk_Prediction.png
// module id = g7nj
// module chunks = 0